import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { fieldErrors } from '@/hooks/useApiError';

/** The editor's copy of `GET /companies/me/branding`. */
export const BRANDING_KEY = ['company-branding'];

/**
 * Every branding write answers with the whole editor view, completion
 * included, so a write replaces the cached copy rather than refetching it.
 * The public page is invalidated too, in case it is open in another view.
 */
export function useApplyBranding() {
  const queryClient = useQueryClient();
  return useCallback(
    (branding) => {
      queryClient.setQueryData(BRANDING_KEY, branding);
      void queryClient.invalidateQueries({ queryKey: ['company-public'] });
    },
    [queryClient],
  );
}

/**
 * Server field errors, with Pydantic's "Value error, " prefix removed -- the
 * rest of the sentence is written for a person, the prefix is not.
 */
export function applyBrandingFieldErrors(error, setError) {
  const entries = Object.entries(fieldErrors(error));
  entries.forEach(([field, message]) =>
    setError(field, { type: 'server', message: String(message).replace(/^Value error,\s*/i, '') }),
  );
  return entries.length > 0;
}
